import React, { useEffect, useState } from 'react';
import { compareNaturally, sortObjectArrayNaturally } from '../../lib';
import _ from 'lodash';
import { Data, DataState, isDataLoaded, DeviceChannelCount } from '../../types';
import { useDeviceChannelCount } from '../../data/DataProviders/DeviceChannelCountProvider';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { ManageAlarmsListGroups } from '../../components/ManageAlarms/ManageAlarmsListGroups';
import { ManageAlarmsListItem } from '../../components/ManageAlarms/ManageAlarmsListItem';
import { DeviceDataProvider } from '../../data/DataProviders/DeviceDataProvider';
import { useSelector } from 'react-redux';
import { Selectors } from '../../selectors';
import { EmptyState } from '@brightlayer-ui/react-components';
import { Box } from '@mui/material';
import { ErrorOutline } from '@mui/icons-material';
import { DataIndicators } from '../../components/DataIndicators';

export const ManageAlarmsFilters: React.FC = () => {
    const deviceChannelCountData = useDeviceChannelCount();
    const selectedDevice = useSelector(Selectors.ManageAlarmsSelectors.selectedDevice);
    const [deviceChannelCount, setDeviceChannelCount] = useState<Data<DeviceChannelCount[]>>({
        state: DataState.Loading,
    });
    const { t } = useLanguageLocale();

    useEffect(() => {
        if (isDataLoaded(deviceChannelCountData)) {
            setDeviceChannelCount(deviceChannelCountData);
        }
    }, [deviceChannelCountData]); // eslint-disable-line react-hooks/exhaustive-deps

    const deviceChannelData: DeviceChannelCount[] = isDataLoaded(deviceChannelCount)
        ? sortObjectArrayNaturally(deviceChannelCount.value, [{ sortField: 'deviceName' }, { sortField: 'deviceId' }])
        : [];

    const deviceChannelCountGrp = deviceChannelData.map((value) => ({
        name: value.deviceName,
        id: value.deviceId,
        channelCount: value.channelCount,
    }));

    const deviceChannelDataGroups = isDataLoaded(deviceChannelCount)
        ? _.groupBy(
              deviceChannelData,
              (m) => m.deviceName || t('DASHBOARD.SITE_DETAILS.READING_CARDS.UNKNOWN', m.deviceId)
          )
        : {};

    const deviceChannelGroups = Object.keys(deviceChannelDataGroups)
        .sort(compareNaturally)
        .map((groupName) => ({
            name: groupName,
            items: deviceChannelDataGroups[groupName],
        }));

    return (
        <>
            <div
                data-testid="site-devices-card"
                style={{ marginRight: 50, marginLeft: 50, marginTop: 20, marginBottom: 20 }}
            >
                {deviceChannelGroups && deviceChannelGroups.length > 0 && (
                    <DeviceDataProvider deviceId={selectedDevice || ''}>
                        <ManageAlarmsListGroups
                            groups={deviceChannelCountGrp}
                            component={ManageAlarmsListItem}
                            componentTestId="manage-alarms-item"
                            //  navigationFn={navigateToDeviceDetail}
                        />
                    </DeviceDataProvider>
                )}
                {isDataLoaded(deviceChannelCount) && deviceChannelGroups.length === 0 && (
                    <Box style={{ padding: 8, display: 'flex', justifyContent: 'center' }}>
                        <EmptyState
                            title="No devices found for the selected filters."
                            icon={
                                <div style={{ fontSize: 48 }}>
                                    <ErrorOutline />
                                </div>
                            }
                        />
                    </Box>
                )}
                {!isDataLoaded(deviceChannelCountData) && (
                    <DataIndicators
                        errorMessage=""
                        emptyMessage="Devices not found"
                        inline
                        data={deviceChannelCountData}
                        emptyIcon="Devices"
                        isEmpty={false}
                        isDetailedInfo={false}
                    />
                )}
            </div>
        </>
    );
};
